import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDebounce } from 'react-use';
import styled from 'styled-components';

import { SearchInput } from '@sorare/core/src/atoms/inputs/SearchInput';

const Root = styled.div`
  padding: 0 var(--double-unit);
`;

type Props = {
  onChange: (value: string) => void;
  collectionsCount: number;
};

export const LeagueSearchInput = ({ onChange, collectionsCount }: Props) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState('');
  useDebounce(
    () => {
      onChange(value);
    },
    300,
    [value]
  );
  return (
    <Root>
      <SearchInput
        fullWidth
        small
        rounded
        withIcon
        value={value}
        onChange={event => {
          setValue(event.target.value);
        }}
        placeholder={formatMessage(
          {
            id: 'LeagueSearchInput.placeholder',
            defaultMessage: 'Search {collectionsCount} collections',
          },
          { collectionsCount }
        )}
      />
    </Root>
  );
};
